import PropTypes from "prop-types";
import React from "react";

const LayoutSplitCounter = ({ data, apiData }) => {
  const {
    isTitleHidden,
    chartTitle,
    counterDataType,
    showUnit,
    counterValue,
    bgColor = "#00B1A9",
    bgColor2 = "#a6a6a6a6",
    valueColor,
    valueFontSize,
  } = data;

  const value = apiData?.data || {};
  const unit = apiData?.unit || "";

  return (
    <div className="p-2 w-100">
      <div className="d-flex">
        <div className="mr-1 border px-2 py-3 flex-1" style={{ backgroundColor: bgColor, color: "#fff" }}>
          {!isTitleHidden && (
            <div className="ql">
              <div className="ql-editor p-0 pb-1" style={{ textAlign: "center" }}>
                <div dangerouslySetInnerHTML={{ __html: chartTitle }}></div>
              </div>
            </div>
          )}
        </div>
        <div
          className="border px-2 py-3 text-white flex-1 d-flex align-items-center justify-content-center"
          style={{ background: bgColor2, textAlign: "center" }}
        >
          <h3 className="mb-0" style={{ fontSize: valueFontSize ? `${valueFontSize}pt` : "14pt", color: valueColor }}>
            {counterDataType === "custom" ? counterValue : value?.value ? Number(value.value).toFixed(2) : 0}
            {showUnit && Boolean(unit) ? <strong>{unit}</strong> : ""}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default LayoutSplitCounter;

LayoutSplitCounter.propTypes = {
  data: PropTypes.object.isRequired,
  mainDashboard: PropTypes.bool,
  apiData: PropTypes.object,
};
